import {Options} from "@interstate/components/RadioButtonList";
import {ClientPhoneNumber} from "./ClientPhoneNumber";

/**
 * The {@link toRadioButtonOption} function converts a {@link ClientPhoneNumber}
 * into an {@link Options} object suitable for use in a {@link RadioButtonList}.
 *
 * @param phone
 *
 * @see {@link labelForPrimaryAddress}
 */
export const toRadioButtonOption = (phone: ClientPhoneNumber): Options => ({
  value: phone.key,
  label: `${phone.entity.custName}\n${phone.number}`
});
